import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const NO_ADMIN_BYPASS_PREFIX = 'portal.';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private permissionsSubject: BehaviorSubject<string[]> = new BehaviorSubject<
    string[]
  >([]);
  public permissions$: Observable<string[]> =
    this.permissionsSubject.asObservable();

  private loadingSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  public loading$: Observable<boolean> = this.loadingSubject.asObservable();

  constructor() {
    const savedPermissions = localStorage.getItem('userPermissions');
    if (savedPermissions) {
      this.permissionsSubject.next(JSON.parse(savedPermissions));
    }
  }

  setPermissions(permissions: string[]): void {
    //console.log('PermissionService: Setting permissions:', permissions);
    localStorage.setItem('userPermissions', JSON.stringify(permissions));
    this.permissionsSubject.next(permissions);
    this.loadingSubject.next(false);
  }

  setLoading(isLoading: boolean): void {
    //console.log('PermissionService: Setting loading status to:', isLoading);
    this.loadingSubject.next(isLoading);
  }

  get isLoading(): boolean {
    return this.loadingSubject.value;
  }

  hasPermission(permissionName: string): boolean {
    if (permissionName.startsWith(NO_ADMIN_BYPASS_PREFIX)) {
      return this.permissionsSubject.value.includes(permissionName);
    }

    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // If user is Admin, grant all permissions
    if (
      currentUser &&
      (currentUser.role === 'Admin' ||
        currentUser.role === 0 ||
        currentUser.user?.role === 0 ||
        currentUser.user?.role === 1)
    ) {
      return true;
    }

    // Explicit bypass for Funder (role 4) on transactions
    if (
      currentUser &&
      (currentUser.user?.role === 4 || currentUser.role === 4)
    ) {
      if (permissionName === 'listpayments.view') {
        return true;
      }
    }

    const has = this.permissionsSubject.value.includes(permissionName);
    if (!has) {
      console.warn(
        `PermissionService: Access denied for '${permissionName}'. User permissions:`,
        this.permissionsSubject.value,
      );
    }
    return has;
  }

  clearPermissions(): void {
    localStorage.removeItem('userPermissions');
    this.permissionsSubject.next([]);
    this.loadingSubject.next(false);
  }
}
